import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/Dashboard";
import AddItem from "./pages/AddItem";
import StockIn from "./pages/StockIn";
import StockOut from "./pages/StockOut";
import Balance from "./pages/Balance";
import OutOfStock from "./pages/OutOfStock";
import Profile from "./pages/Profile";
import Transfer from "./pages/transfer";
import Login from "./pages/login";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="n" element={<Sidebar />}>
          {/* Protected Routes */}
          <Route
            index
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="add-item"
            element={
              <ProtectedRoute>
                <AddItem />
              </ProtectedRoute>
            }
          />
          <Route
            path="stock-in"
            element={
              <ProtectedRoute>
                <StockIn />
              </ProtectedRoute>
            }
          />
          <Route
            path="stock-out"
            element={
              <ProtectedRoute>
                <StockOut />
              </ProtectedRoute>
            }
          />
          <Route
            path="balance"
            element={
              <ProtectedRoute>
                <Balance />
              </ProtectedRoute>
            }
          />
          <Route
            path="out-of-stock"
            element={
              <ProtectedRoute>
                <OutOfStock />
              </ProtectedRoute>
            }
          />
          <Route
            path="profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="transfer"
            element={
              <ProtectedRoute>
                <Transfer />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
